import { render, staticRenderFns } from "./LayoutSetting.vue?vue&type=template&id=22d416b6&scoped=true&"
import script from "./LayoutSetting.vue?vue&type=script&lang=js&"
export * from "./LayoutSetting.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSetting.vue?vue&type=style&index=0&id=22d416b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d416b6",
  null
  
)

export default component.exports